import { relations, sql } from "drizzle-orm";
import { check, pgTable, text, timestamp, unique, uuid, varchar, } from "drizzle-orm/pg-core";
import { dataRequestTable } from "./dataRequest.js";
import { dossier } from "./dossier.js";
import { hdnInformatieAanvraagTable, hdnLoanApplication } from "./hdn.js";
import { agency, appUser } from "./main.js";
export const WorkItemKind = [
    "informatie_aanvraag_review",
    "data_request_review",
    "loan_application_document_review",
];
export const WorkItemStatus = ["open", "completed"];
export const WorkItemPhase = ["connect", "send", "ai_review"];
export const workItem = pgTable("work_item", {
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    kind: text("kind").notNull().$type(),
    status: text("status")
        .default("open")
        .notNull()
        .$type(),
    phase: text("phase").$type(),
    title: varchar("title", { length: 255 }).notNull(),
    description: text("description"),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    dossierId: uuid("dossier_id")
        .notNull()
        .references(() => dossier.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    informatieAanvraagId: uuid("informatie_aanvraag_id").references(() => hdnInformatieAanvraagTable.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    dataRequestId: uuid("data_request_id").references(() => dataRequestTable.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    loanApplicationId: uuid("loan_application_id").references(() => hdnLoanApplication.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    ownerUserId: uuid("owner_user_id").references(() => appUser.id, {
        onDelete: "set null",
        onUpdate: "cascade",
    }),
    ownerAssignedAt: timestamp("owner_assigned_at", {
        withTimezone: true,
        mode: "string",
    }),
    resolvedAt: timestamp("resolved_at", {
        withTimezone: true,
        mode: "string",
    }),
    resolvedByUserId: uuid("resolved_by_user_id").references(() => appUser.id, {
        onDelete: "set null",
        onUpdate: "cascade",
    }),
    updatedAt: timestamp("updated_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
}, (table) => ({
    informatieAanvraagUnique: unique("work_item_informatie_aanvraag_id_key").on(table.informatieAanvraagId),
    dataRequestUnique: unique("work_item_data_request_id_key").on(table.dataRequestId),
    loanApplicationPhaseUnique: unique("work_item_loan_application_phase_key").on(table.loanApplicationId, table.phase),
    kindShape: check("work_item_kind_shape_check", sql `
				(
					${table.kind} = 'informatie_aanvraag_review'
					and ${table.informatieAanvraagId} is not null
					and ${table.dataRequestId} is null
					and ${table.loanApplicationId} is null
					and ${table.phase} is null
				)
				or (
					${table.kind} = 'data_request_review'
					and ${table.dataRequestId} is not null
					and ${table.informatieAanvraagId} is null
					and ${table.loanApplicationId} is null
					and ${table.phase} is null
				)
				or (
					${table.kind} = 'loan_application_document_review'
					and ${table.loanApplicationId} is not null
					and ${table.phase} is not null
					and ${table.informatieAanvraagId} is null
					and ${table.dataRequestId} is null
				)
			`),
    resolutionState: check("work_item_resolution_state_check", sql `
				(
					${table.status} = 'open'
					and ${table.resolvedAt} is null
					and ${table.resolvedByUserId} is null
				)
				or (
					${table.status} = 'completed'
					and ${table.resolvedAt} is not null
				)
			`),
}));
export const workItemRelations = relations(workItem, ({ one }) => ({
    agency: one(agency, {
        fields: [workItem.agencyId],
        references: [agency.id],
    }),
    dossier: one(dossier, {
        fields: [workItem.dossierId],
        references: [dossier.id],
    }),
    informatieAanvraag: one(hdnInformatieAanvraagTable, {
        fields: [workItem.informatieAanvraagId],
        references: [hdnInformatieAanvraagTable.id],
    }),
    dataRequest: one(dataRequestTable, {
        fields: [workItem.dataRequestId],
        references: [dataRequestTable.id],
    }),
    loanApplication: one(hdnLoanApplication, {
        fields: [workItem.loanApplicationId],
        references: [hdnLoanApplication.id],
    }),
    owner: one(appUser, {
        relationName: "workItemOwner",
        fields: [workItem.ownerUserId],
        references: [appUser.id],
    }),
    resolvedBy: one(appUser, {
        relationName: "workItemResolvedBy",
        fields: [workItem.resolvedByUserId],
        references: [appUser.id],
    }),
}));
